import { FormsModule } from '@angular/forms';
import { NewProjectComponent } from './new-project/new-project.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProjectRoutingModule } from './project-routing.module';
import { ConfirmationDialogComponent } from '../test/test-step/confirmation-dialog/confirmation-dialog.component';
import { RenameComponent } from './rename/rename.component';
import { AddModuleComponent } from './add-module/add-module.component';

import { AddParentModuleComponent } from './add-parent-module/add-parent-module.component';
import { AddSuiteModuleComponent } from './add-suite-module/add-suite-module.component';
import { ImportComponent } from './import/import.component';
import { UpdateLocatorComponent } from './locators/update-locator/update-locator.component';

import { CreateLocatorsComponent } from './locators/create-locators/create-locators.component';
import { LocatorComponent } from './locators/locator/locator.component';
import { LocatorHistoryComponent } from './locators/locator-history/locator-history.component';
import { ProjectComponent } from './project.component';
import { AngularMaterialModule } from '../angular-material.module';
import { SharedModule } from '../shared/shared.module';
import { StartComponent } from './start/start.component';
import { TestModuleComponent } from './test-module/test-module.component';
import { LayoutModule } from '../layout/layout.module';
import { TestSuiteComponent } from './test-suite/test-suite.component';
import { LocatorScreenComponent } from './locator-screen/locator-screen.component';

@NgModule({
    declarations: [RenameComponent,
        AddModuleComponent,
        AddParentModuleComponent,
        AddSuiteModuleComponent,
        ImportComponent,
        CreateLocatorsComponent,
        LocatorComponent,
        LocatorHistoryComponent,
        UpdateLocatorComponent,
        ProjectComponent,
        StartComponent,
        TestModuleComponent,
        NewProjectComponent,
        TestSuiteComponent,
        LocatorScreenComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        AngularMaterialModule,
        ProjectRoutingModule,
        LayoutModule,
        SharedModule
    ],
    exports: [ProjectComponent]
})
export class ProjectModule { }
